/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of the subscription.
 * @export
 */
export const SubscriptionStatus = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED'
} as const;
export type SubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];


export function instanceOfSubscriptionStatus(value: any): boolean {
    for (const key in SubscriptionStatus) {
        if (Object.prototype.hasOwnProperty.call(SubscriptionStatus, key)) {
            if (SubscriptionStatus[key as keyof typeof SubscriptionStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubscriptionStatusFromJSON(json: any): SubscriptionStatus {
    return SubscriptionStatusFromJSONTyped(json, false);
}

export function SubscriptionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionStatus {
    return json as SubscriptionStatus;
}

export function SubscriptionStatusToJSON(value?: SubscriptionStatus | null): any {
    return value as any;
}

export function SubscriptionStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SubscriptionStatus {
    return value as SubscriptionStatus;
}

